var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentStatusPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 41,
    r: 30.5,
    stroke: "#D4BC87"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.25 41L56.75 44.5L53.25 41",
    stroke: "#D4BC87",
    strokeWidth: 1.3125,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6875 32.2502V41.0002L44.9375 46.2502",
    stroke: "#D4BC87",
    strokeWidth: 1.3125,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41 56.75C32.3015 56.75 25.25 49.6985 25.25 41C25.25 32.3015 32.3015 25.25 41 25.25C49.6985 25.25 56.75 32.3015 56.75 41C56.75 40.9352 56.75 42.75 56.75 42.75",
    stroke: "#D4BC87",
    strokeWidth: 1.3125,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0166 49.8669C49.1195 57.056 39.3218 58.914 32.1328 54.017C24.9437 49.1199 23.0857 39.3222 27.9827 32.1331C32.8798 24.9441 42.6775 23.0861 49.8665 27.9831C49.813 27.9466 51.3129 28.9683 51.3129 28.9683",
    stroke: "#D4BC87",
    strokeWidth: 1.3125,
    strokeLinecap: "round",
    strokeDasharray: "2.62 2.62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentStatusPending);
export default __webpack_public_path__ + "static/media/payment-status-pending.772d06c58b0e58cea1f9349beb52fa43.svg";
export { ForwardRef as ReactComponent };